<template>
  <div :key="this.$i18n.locale + this.$route.path">
    <div
      class="banner"
      @click="$router.push('/prematch/sport/1/league/13921')"
    ></div>
    <!--m-widget-head class="matches-head" style="margin-right: 10px !important; height: 50px;">
      <div class="tabs flex" style="margin-right: 50%; height: 50px;">
        <active-button
          :active="false"
          @click="$router.push('/')"
          style="height: 50px; line-height: 50px; font-weight: bold; font-style: italic;"
        >
          Live
        </active-button>
      </div>
      <template slot="right">
        <div class="menu-layout">
          <m-scrollbar>
            <live-menu v-if="isActive('section', 'live')" />
          </m-scrollbar>
        </div>
      </template>
    </m-widget-head-->
    <div class="video" style="height: 30px; line-height: 30px; background: linear-gradient(to top right,#713592,#342d6e); display: flex; margin-right: 10px; border-radius: 10px; margin-top: 4px;" v-if="!isActive('page', 'upcoming')">
      <active-button
        :active="!$route.params.video && !isActive('page', 'upcoming')"
        @click="$router.push('/')"
        style="margin-right: 30px; margin-left: 10px; width: 46px;"
      >
        <span style="color: red;">&nbsp;Live&nbsp;</span>
        <span style="font-size: 10px; font-weight: bold; margin-top: -5px; position: absolute; color: white;">{{ this.countEvents }}</span>
      </active-button>
      <active-button
        :active="$route.params.video && !isActive('page', 'upcoming')"
        @click="$router.push('/video/1')"
        style="margin-right: 30px; width: 55px;"
        v-if="this.$i18n.locale == 'ru'"
      >
        <span style="color: white;">&nbsp;Видео&nbsp;</span>
        <span style="font-size: 10px; font-weight: bold; margin-top: -5px; position: absolute; color: white;">{{ this.countEventsVideo }}</span>
      </active-button>
      <active-button
        :active="$route.params.video && !isActive('page', 'upcoming')"
        @click="$router.push('/video/1')"
        style="margin-right: 30px; width: 55px;"
        v-if="this.$i18n.locale == 'en'"
      >
        <span style="color: white;">&nbsp;Video&nbsp;</span>
        <span style="font-size: 10px; font-weight: bold; margin-top: -5px; position: absolute; color: white;">{{ this.countEventsVideo }}</span>
      </active-button>
      <active-button
        :active="$route.params.video && !isActive('page', 'upcoming')"
        @click="$router.push('/video/1')"
        style="margin-right: 30px; width: 55px;"
        v-if="this.$i18n.locale == 'az'"
      >
        <span style="color: white;">&nbsp;Video&nbsp;</span>
        <span style="font-size: 10px; font-weight: bold; margin-top: -5px; position: absolute; color: white;">{{ this.countEventsVideo }}</span>
      </active-button>
      <!--active-button
        :active="isActive('page', 'upcoming')"
        @click="$router.push('/live/upcoming')"
      >
        <div>&nbsp;{{ $t('live.upcoming') }}&nbsp;</div>
      </active-button-->
    </div>
    <hooper :itemsToShow="8" pagination="yes" style="margin-top: 1px; margin-right: 10px;" ref="carousel" v-if="!$route.params.video && !isActive('page', 'upcoming')">
      <slide
        v-for="sport in sports"
        :key="sport.id"
        line-color="blue"
        :active="$route.params.sport === sport.id"
        :title="sport.name"
        :style="{ background: 'rgba(0,0,0,0.25)', cursor: 'pointer'}"
        :class="((!$route.params.sport && sport.id == 1) || $route.params.sport == sport.id) ? 'active' : ''"
      >
        <div @click="$route.params.video ? $router.push(`/home/live/sport/${sport.id}/video/1`) : $router.push(`/home/live/sport/${sport.id}`)">
          <ul :style="{listStyle: 'none', textAlign: 'center', marginTop: '10px'}">
            <li>
              <span><sport-icon-liga-white :name="sport.alias" /></span>
              <span class="events-count">{{ sport.events.length }}</span>
            </li>
            <li>
              <span>{{sport.name}}</span>
            </li>
          </ul>
        </div>
      </slide>
      <hooper-navigation slot="hooper-addons"></hooper-navigation>
    </hooper>
    <hooper :itemsToShow="8" pagination="yes" style="margin-top: 1px; margin-right: 10px;" ref="carousel" v-if="$route.params.video">
      <slide
        v-for="sport in sportsVideo"
        :key="sport.id"
        line-color="blue"
        :active="$route.params.sport === sport.id"
        :title="sport.name"
        :style="{ background: 'rgba(0,0,0,0.25)', cursor: 'pointer'}"
        :class="((!$route.params.sport && sport.id == 1) || $route.params.sport == sport.id) ? 'active' : ''"
      >
        <div @click="$route.params.video ? $router.push(`/home/live/sport/${sport.id}/video/1`) : $router.push(`/home/live/sport/${sport.id}`)">
          <ul :style="{listStyle: 'none', textAlign: 'center', marginTop: '10px'}">
            <li>
              <span><sport-icon-liga-white :name="sport.alias" /></span>
              <span class="events-count">{{ sport.events.length }}</span>
            </li>
            <li>
              <span>{{sport.name}}</span>
            </li>
          </ul>
        </div>
      </slide>
      <hooper-navigation slot="hooper-addons"></hooper-navigation>
    </hooper>
    <router-view />
  </div>
</template>

<script>
import MWidgetHead from '@/components/widget/MWidgetHead'
import ActiveButton from '@/components/buttons/ActiveButton'
import LiveMenu from '@/components/sports/main/live/Menu'
import PopularMenu from '@/components/sports/main/popular/Menu'
import MScrollbar from '@/components/MScrollbar'
import SportIconLigaWhite from '@/components/icons/SportIconLigaWhite'
import IconButton from '@/components/buttons/IconButton'
import ArrowIcon from '@/components/icons/ArrowIconWhite'
import { Hooper, Slide, Navigation as HooperNavigation } from 'hooper'
import 'hooper/dist/hooper.css'
import { mapState } from 'vuex'

export default {
  components: {
    MWidgetHead,
    ActiveButton,
    LiveMenu,
    PopularMenu,
    MScrollbar,
    Hooper,
    Slide,
    HooperNavigation,
    SportIconLigaWhite,
    ArrowIcon,
    IconButton
  },
  computed: {
    ...mapState({
      sports: state => state.live.menu,
      sportsVideo: state => state.live.menuVideo
    })
  },
  data () {
    return {
      updateInterval: null,
      countEvents: 0,
      countEventsVideo: 0
    }
  },
  mounted () {
    const dispatchGetting = () => {
      this.$store.dispatch('live/GET_MENU_SPORTS')
      this.$store.dispatch('live/GET_MENU_SPORTS_VIDEO')
      this.countEvents = 0
      this.countEventsVideo = 0
      this.sports.forEach((sport) => {
        this.countEvents += sport.events.length
      })
      this.sportsVideo.forEach((sport) => {
        this.countEventsVideo += sport.events.length
      })
    }
    dispatchGetting()
    this.updateInterval = setInterval(function () {
      dispatchGetting()
    }, 2000)
  },
  beforeDestroy () {
    clearInterval(this.updateInterval)
  },
  watch: {
    '$i18n.locale' (to, from) {
      this.$store.dispatch('live/GET_UPCOMING')
    }
  },
  methods: {
    slidePrev () {
      this.$refs.carousel.slidePrev()
    },
    slideNext () {
      this.$refs.carousel.slideNext()
    },
    goBack () {
      if (this.$route.path === '/live/upcoming') this.$router.push('/live')
      if (this.$route.params.event !== undefined) this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.matches-head { background: #263238; margin: 0 10px 5px; position: relative; z-index: 1; }

.banner { background: url(../../../assets/banners/1600x200-champions-league-uefa.jpg); background-position-x: 50%; border-radius: 5px; cursor: pointer; height: 200px; margin: 10px 10px 0; opacity: .9; -webkit-transition: opacity .3s; -moz-transition: opacity .3s; -o-transition: opacity .3s; transition: opacity .3s; display: none;}
.banner:hover { opacity: 1; }

.tabs .active-button { height: 40px; line-height: 40px; padding: 0 10px; }

.menu-layout { background: rgba(0, 0, 0, .05); border-bottom: 1px solid rgba(255, 255, 255, .05); height: 50px; padding: 0; width: 100%; }
.menu-layout .scroll-area { height: 50px; }

.live-widget-head { background: rgba(0,0,0,0.25); position: relative; z-index: 1; margin-top: 5px;  margin-bottom: 5px; font-size: 16px; }
.live-widget-head .tabs .active-button { height: 40px; line-height: 40px; padding: 0 10px; }
.live-widget-head .tabs .active-button:hover { background: #8ce95d; }
.events-count { z-index: 1; font-weight: 700; position: absolute; margin-left: 5px; }
.active { background: #8ce95d !important; }
.banner { height: 250px; width: 100%; background: rgba(0,0,0,0.35); border-radius: 10px; }

</style>



// WEBPACK FOOTER //
// src/components/sports/main/Main.vue